import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { ReferralStateType } from "types/referral";

import { extraReducers } from "./referral.extraReducers";
export const initialState: ReferralStateType = {
  isLoading: false,
  dataReferral: {
    data: {
      code: "",
      referral: {
        total: 0,
        detail: [
          {
            member_id: "",
            registered_date: "",
            total_comm: "",
          },
        ],
      },
      valid_referral: {
        total: 0,
        detail: [
          {
            member_id: "",
            registered_date: "",
            total_turnover: "",
          },
        ],
      },
      reward: {
        total: "",
        detail: [
          {
            date: "",
            distribution_time: "",
            total_reward: "",
            total_turnover: "",
          },
        ],
      },
      registered_active: {
        active_player: [],
        registered_player: [],
        total_active_player: 0,
        total_registered_player: 0,
        inactive_player: [],
        total_inactive_player: 0,
      },
      last_deposit: {
        amount: "",
        created_date: "",
        deposit_id: "",
        transaction_code: "",
        username: "",
      },
    },
  },
};

const referralSlice = createSlice({
  name: "referral",
  initialState,
  reducers: {
    //
  },
  extraReducers,
});

export const selectDataReferral = (state: ApplicationRootState) =>
  state.referral.dataReferral.data;
export const selectLoadingReferral = (state: ApplicationRootState) =>
  state.referral.isLoading;

export default referralSlice.reducer;
